import type { ErrorHandler } from '@/types/errorHandler';

/** Fallback handler when Datadog is disabled. Shared by the server + client factories. */
export class ConsoleErrorHandler implements ErrorHandler {
  logError(error: Error, additionalContext: object = {}) {
    // eslint-disable-next-line no-console
    console.log({
      error,
      additionalContext,
    });
  }

  logWarning(error: Error, additionalContext: object = {}) {
    // eslint-disable-next-line no-console
    console.log({
      error,
      additionalContext,
    });
  }

  logInfo(error: Error, additionalContext: object = {}) {
    // eslint-disable-next-line no-console
    console.log({
      error,
      additionalContext,
    });
  }
}
